// NOTE NOTE NOTE: This is a mapping of Authzed relations for easy lookup. These references are actually
// defined on the backend in the Capability type and associated Authzed schema; this is just a codified lookup
// table.
export const AUTHZED_RELATIONS = {
  globalCategoriesViewer: 'global_categories_viewer',
  globalCategoriesEditor: 'global_categories_editor',
  promptViewer: 'prompt_viewer',
  promptEditor: 'prompt_editor',
  advisorClientRelationshipOwner: 'advisor_client_relationship_owners',
  advisorClientAllClients: 'advisor_client_all_clients',
  approveSupportAccess: 'support_access_approver',
  tenantReportingViewer: 'tenant_reporting_viewer',
  presentationApprover: 'presentation_approver',

  branding: {
    editor: 'brand_editor',
  },

  employees: {
    viewer: 'employee_viewer',
    editor: 'employee_editor',
    admin: 'employee_admin',
  },

  collaborators: {
    viewer: 'collaborator_viewer',
    editor: 'collaborator_editor',
    admin: 'collaborator_admin',
  },

  households: {
    viewer: 'advisor_client_viewer',
    editor: 'advisor_client_editor',
    admin: 'advisor_client_admin',
  },

  auditLogs: {
    viewer: 'audit_logs_viewer',
    admin: 'audit_logs_admin',
  },

  waterfall: {
    presenter: 'estate_waterfall_presenter',
    editor: 'estate_waterfall_editor',
  },

  dispositiveProvisions: {
    editor: 'dispositive_provisions_editor',
  },

  roles: {
    viewer: 'role_viewer',
    editor: 'role_editor',
    admin: 'role_admin',
  },

  presentationTemplates: {
    viewer: 'tenant_presentation_templates_viewer',
    admin: 'tenant_presentation_templates_admin',
  },
} as const;
